(function () {
  function initSlideUp(options = {}) {
    const {
      selector = '[data-slide-up]',
      loadedClass = 'slide-up-loaded',

      // 进入视口即触发
      threshold = 0,
      root = null,
      rootMargin = '0px',

      // 分组递增：同组内按顺序递增 delay（不封顶，按你现在需求）
      groupSelector = '[data-slide-up-group]',
      staggerStepMs = 40,

      // 禁用：这些区域内加载时直接 remove data-slide-up
      excludeClassList = [],
      excludeSelectorList = [],

      // 修复初始滚动定位
      fixInitialScrollRestore = true,

      // 动态 DOM 也支持
      watchDom = true,
    } = options;

    const supportsIO = 'IntersectionObserver' in window;
    let io = null;
    let mo = null;

    const excludeSelectors = [
      ...(excludeClassList || []).filter(Boolean).map(c => (c.startsWith('.') ? c : '.' + c)),
      ...(excludeSelectorList || []).filter(Boolean),
    ];

    const qsa = (container = document, sel = selector) =>
      Array.from(container.querySelectorAll(sel));

    function shouldExclude(el) {
      if (!excludeSelectors.length) return false;
      return excludeSelectors.some(sel => !!el.closest(sel));
    }

    function disableInContainer(container = document) {
      const els = qsa(container);
      for (const el of els) {
        if (shouldExclude(el)) {
          el.removeAttribute('data-slide-up');
          el.classList.remove(loadedClass);
          delete el.dataset.slideUpDone;
          delete el.dataset.slideUpDelaySet;
        }
      }
    }

    // 递增 delay（同组内从 0,90,180...）
    const groupCounters = new WeakMap();
    function getGroupEl(el) {
      const g = el.closest(groupSelector);
      return g || el.parentElement || document.body;
    }

    function setIncrementDelay(el) {
      if (el.dataset.slideUpDelaySet === '1') return;
      if (!el.hasAttribute('data-slide-up')) return;
      if (shouldExclude(el)) return;

      // 你手动写了 --su-delay 就不覆盖
      if (el.style.getPropertyValue('--su-delay')) {
        el.dataset.slideUpDelaySet = '1';
        return;
      }

      const groupEl = getGroupEl(el);
      const cur = groupCounters.get(groupEl) || 0;
      el.style.setProperty('--su-delay', (cur * staggerStepMs) + 'ms');
      el.dataset.slideUpDelaySet = '1';
      groupCounters.set(groupEl, cur + 1);
    }

    function addLoadedOnce(el) {
      if (el.dataset.slideUpDone === '1') return;
      setIncrementDelay(el);
      el.classList.add(loadedClass);
      el.dataset.slideUpDone = '1';
    }

    function ensureIO() {
      if (!supportsIO) return null;
      if (io) return io;

      io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const el = entry.target;
          if (!el.hasAttribute('data-slide-up')) continue;
          if (shouldExclude(el)) continue;

          if (entry.isIntersecting) {
            addLoadedOnce(el);
            io.unobserve(el); // 只执行一次
          }
        }
      }, { root, rootMargin, threshold });

      return io;
    }

    function observe(container = document) {
      disableInContainer(container);

      const els = qsa(container).filter(el => !shouldExclude(el));
      if (!supportsIO) {
        // 老浏览器兜底：直接显示
        els.forEach(addLoadedOnce);
        return;
      }

      const observer = ensureIO();
      els.forEach(el => observer.observe(el));
    }

    // 初始定位补偿：解决“页面打开在下面，滚动后有些不触发”
    function manualCheck(container = document) {
      const els = qsa(container).filter(el => !shouldExclude(el));
      const vh = window.innerHeight || document.documentElement.clientHeight;

      for (const el of els) {
        if (el.dataset.slideUpDone === '1') continue;
        const r = el.getBoundingClientRect();
        const inTriggerZone = r.bottom > 0 && r.top < vh;
        if (inTriggerZone) addLoadedOnce(el);
      }
    }

    function refresh(container = document) {
      observe(container);
      requestAnimationFrame(() =>
        requestAnimationFrame(() => manualCheck(container))
      );
    }

    function init(container = document) {
      // 先标记视口内元素，再启用隐藏样式，避免 JS 慢加载时整页 opacity:0
      manualCheck(container);
      document.documentElement.classList.add('slide-up-active');
      refresh(container);

      if (fixInitialScrollRestore) {
        window.addEventListener('load', () => refresh(container), { once: true });
        window.addEventListener('pageshow', () => refresh(container));
      }

      if (watchDom) {
        mo = new MutationObserver((mutations) => {
          for (const m of mutations) {
            for (const node of m.addedNodes) {
              if (!(node instanceof Element)) continue;
              if (node.querySelectorAll) refresh(node);
            }
          }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
      }
    }

    function destroy() {
      if (io) { io.disconnect(); io = null; }
      if (mo) { mo.disconnect(); mo = null; }
    }

    return { init, refresh, destroy };
  }

  window.initSlideUp = initSlideUp;
})();
